<!-- <div class="topbar clearfix tecfolk-fix-p-message topbar-hide-on-mobile">
    <div class="topbar-left" style="padding:0 !important;">
        <div class="logo">
            <img [src]="
            (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                style="width: 124%; height: 75px; margin-left: 0px;" />

        </div>
        <div  style="position: absolute !important; left: 19em; bottom: 1rem;" class="topbar-right">
            <a pTooltip="Hide Menu" id="menu-button" href="#" (click)="app.onMenuButtonClick($event)">
                <i></i>
            </a>
        </div>

    </div>

    <div style="display: flex; flex-direction: column; align-items: center;">
            <p-message severity={{licencestate}} text="{{licenseMessage}}" styleClass="p-mr-6"></p-message>

        <span class="topbar-text">{{branchName}}</span>

    </div>

    <div class="topbar-right">

        <button (click)="openVisitorDialogue()" pButton type="button" icon="fa fa-plus"
            style="display: none; background-color: #51d066; position: absolute; bottom: 10px; left: 90%; transform: translateX(-50%);"
            class="p-button-success">&nbsp;{{setLabel("addVisitorLabel")}}</button>

        <button (click)="openPettyCashDialogue()" pButton type="button" icon="fa fa-plus" *ngIf="hasPettyCashAccount"
            style="width: max-content; background-color: #37a8ca; position: absolute; bottom: 10px; left: 90%; transform: translateX(-50%);"
            class="p-button-success">&nbsp;{{setLabel("addPettyCashLabel")}}</button>

        <button (click)="openPettyLendingDialog()" pButton type="button" icon="fa fa-plus" *ngIf="hasPettyCashAccount"
            style="width: max-content; background-color: #37a8ca; position: absolute; bottom: 10px; left: 79%; transform: translateX(-50%);"
            class="p-button-success">&nbsp;{{setLabel("pettyLendingLabel")}} </button>

        <a id="topbar-menu-button" href="#" (click)="app.onTopbarMenuButtonClick($event)">
            <i class="material-icons">{{setLabel("menuLabel")}}</i>
        </a>
        <ul class="topbar-items animated fadeInDown" [ngClass]="{'topbar-items-visible': app.topbarMenuActive}">
            <li #notifications [ngClass]="{'active-top-menu':app.activeTopbarItem === notifications}">
                <a [pTooltip]='setLabel("duesNotificationsTooltipLabel")' style="cursor: pointer"
                    (click)="app.onRightPanelButtonClick($event)">
                    <i class="topbar-icon fa fa-bell-o" aria-hidden="true"></i>
                    <span class="topbar-badge animated rubberBand">{{notifyArray}}</span>
                    <span class="topbar-item-name">{{setLabel("notificationsLabel")}}</span>
                </a>
                <ul class="ultima-menu animated fadeInDown">
                    <li role="menuitem">
                        <a href="#" (click)="app.onTopbarSubItemClick($event)">
                            <i class="material-icons">bug_report</i>
                            <span>{{setLabel("pendingTasksLabel")}}</span>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</div> -->
<div class="topbarNewStyle">
    <div class="logoMain">
        <img [src]="(bannerImage ? config.Server + 'assets/layout/images/companies/' + bannerImage : 'assets/layout/images/logoCompany.png')"/>
    </div>
    <div class="toolbarMain">
        <div class="menuToggleBtn">
            <div class="ToggleBtn" *ngIf="selectedlanguage == 'en'">
                <a [pTooltip]="menuStateOpen ? 'Hide Menu' : 'Show Menu'" id="menu-button" href="#" (click)="app.onMenuButtonClick($event); onMenuClickState();">
                    <i>{{menuStateOpen ? 'chevron_left' : 'chevron_right'}}</i>
                </a>
            </div>
            <div class="ToggleBtn" *ngIf="selectedlanguage == 'ar'">
                <a [pTooltip]="menuStateOpen ? 'إخفاء القائمة' : 'عرض القائمة'" id="menu-button" href="#" (click)="app.onMenuButtonClick($event); onMenuClickState();">
                    <i>{{menuStateOpen ? 'chevron_right' : 'chevron_left'}}</i>
                </a>
            </div>
            <div class="ToggleBtn" *ngIf="selectedlanguage == 'ur'">>
                <a [pTooltip]="menuStateOpen ? 'مینو چھپائیں':'مینو دکھائیں'" id="menu-button" href="#" (click)="app.onMenuButtonClick($event); onMenuClickState();">
                    <i>{{menuStateOpen ? 'chevron_right' : 'chevron_left'}}</i>
                </a>
            </div>
            <div class="ToggleBtn" *ngIf="selectedlanguage == 'ps' && app.isMobile() !== true">
                <a [pTooltip]="menuStateOpen ? 'مینو پټ کړئ':'مینو وښایاست'" id="menu-button" href="#" (click)="app.onMenuButtonClick($event); onMenuClickState();">
                    <i>{{menuStateOpen ? 'chevron_right' : 'chevron_left'}}</i>
                </a>
            </div>
        </div>
        <div class="branchAndLicenceInfo">
            <p-message severity={{licencestate}} text="{{licenseMessage}}"></p-message>
            <span class="branchName">{{branchName}}</span>
        </div>
        <div  class="toolbatBtns">
            <!-- <button (click)="openVisitorDialogue()" pButton type="button" icon="fa fa-plus"
                style="display: none; background-color: #51d066; "
                class="p-button-success">&nbsp;{{setLabel("addVisitorLabel")}}</button>
            <button (click)="openPettyCashDialogue()" pButton type="button" icon="fa fa-plus" *ngIf="hasPettyCashAccount"
                style="width: max-content; background-color: #37a8ca;"
                class="p-button-success">&nbsp;{{setLabel("addPettyCashLabel")}}</button>
            <button (click)="openPettyLendingDialog()" pButton type="button" icon="fa fa-plus" *ngIf="hasPettyCashAccount"
                style="width: max-content; background-color: #37a8ca;"
                class="p-button-success">&nbsp;{{setLabel("pettyLendingLabel")}} </button> -->
                <div style="position: relative;">
                    <div *ngIf="gymPackage != 'standard'">
                        <button style="border-radius: 5px;" (click)="menu.toggle($event)" pButton type="button"
                            class="p-button-success">{{setLabel("quickAccessLabel")}}</button>
                    </div>
                    <p-menu #menu [model]="items" [popup]="true" />
                </div>
            <a class="duesNotificationsBtn" [pTooltip]='setLabel("duesNotificationsTooltipLabel")' (click)="app.onRightPanelButtonClick($event)">
                <i class="duesNotificationsIcon fa fa-bell-o" aria-hidden="true"></i>
                <span class="duesNotificationsBadge">{{notifyArray}}</span>
            </a>
        </div>
    </div>
</div>

<div *ngIf="visitorDialog">
    <app-visitordialogue (closeVisitorDialog)="closeVisitorDialog()"></app-visitordialogue>
</div>


<div *ngIf="pettyCashDialog" class="tecGym-component appTopbarFix">
    <app-pettycashdialouge (closePettyCashDialog)="closePettyCashDialog()"
        [pettydialogVisibility]="pettyCashDialog"></app-pettycashdialouge>
</div>

<div *ngIf="pettyLendingDialog">
    <app-pettylendingdialog (closePettyLendingDialog)="closePettyLendingDialog()"
        [pettylendingdialogVisibility]="pettyLendingDialog"></app-pettylendingdialog>
</div>